// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Enums / Interfaces
import { ScatterPlotChartOptionValue } from 'ChartApp/ts/enums/scatter-plot-common.enum';
// NgRx actions / selectors
import { setScatterPlot } from '../scatter-plot.actions';
import { setChartOption } from 'ChartApp/ts/apps/scatter-plot/state/chart-options/chart-options.actions';
export const performanceDisclosure = createReducer(false, on(setChartOption, (state, action) => {
    if (action.chartOption.value === ScatterPlotChartOptionValue.performanceDisclosure) {
        return action.chartOption.selected;
    }
    return state;
}), on(setScatterPlot, (state, action) => {
    return action.scatterPlot.performanceDisclosure;
}));
